export const redirectUrlFromSearch = () => {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has("redirect_url")) {
    return searchParams.get("redirect_url");
  } else {
    return null;
  }
};
export const parsedRedirectUrlFromSearch = () => {
  let redirectUrl = redirectUrlFromSearch();
  if (redirectUrl) {
    try {
      new URL(redirectUrl);
      return redirectUrl;
    } catch (e) {
      try {
        redirectUrl = btoa(redirectUrl);
        new URL(redirectUrl);
        return redirectUrl;
      } catch (e) {}
    }
  }
  return null;
};
